module.exports = __webpack_public_path__ + "static/media/La-Bello-Aurore-Regular.c62d32a5.woff";